import { useMutation, useQueryClient } from 'react-query';

import { deleteObject as remove } from 'api/clients/deleteObject';

const useDeleteObject = () => {
  const queryClient = useQueryClient();
  const {
    isSuccess,
    mutate: deleteObject,
    isLoading,
  } = useMutation(remove, {
    onSuccess: () => {
      queryClient.invalidateQueries('objects');
    },
  });

  return {
    isSuccess,
    deleteObject,
    isLoading,
  };
};

export default useDeleteObject;
